import { queryOptions } from "@tanstack/react-query";
import { getZoneGroup } from "../v1/category.service";

export const useZoneGroup = () =>
  queryOptions({
    queryKey: ["zoneGroup-list"],
    queryFn: () => getZoneGroup(),
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
